module.exports = __webpack_public_path__ + "static/media/pre-birth.05cf1741.jpg";